import { useBrandContext } from "@/shared/contexts";
import { useEnv } from "@/contexts/cdpConfig";
/**
 * Generates a brand-specific URL for a given environment (`dev`, `preview`, `live`).
 *
 * @param {Object} params - Configuration parameters
 * @param {string} [params.env] - Optional environment identifier. If not provided, uses the detected environment with `useEnv()`
 * @param {string} [params.endpoint=''] - Optional endpoint to append to the base URL.
 *
 *
 * @example
 * const url = useBrandUrl({ endpoint: '/call-tracking' })
 * const url = useBrandUrl({ env: 'live', endpoint: '/shared/images' })
 */
export const useBrandUrl = ({ env, endpoint = "", } = {}) => {
    const detectedEnv = useEnv();
    const targetEnv = env !== null && env !== void 0 ? env : detectedEnv;
    const { urls } = useBrandContext();
    return `${urls.staging[targetEnv]}${endpoint}`;
};
